// extracted by mini-css-extract-plugin
export var active = "_1f-9";
export var backButton = "_1f-8";
export var clone = "_1f-e";
export var collapseBar = "_1f-k";
export var collapseMode = "_1f-m";
export var collapsed = "_1f-o";
export var dimmed = "_1f-i";
export var dragHandle = "_1f-c";
export var dropdownIcon = "_1f-g";
export var expanding = "_1f-n";
export var hidden = "_1f-x";
export var iconContainer = "_1f-q";
export var iconSwapper = "_1f-w";
export var navItem = "_1f-6";
export var navItemIcon = "_1f-f";
export var navProfile = "_1f-7";
export var notificationCountBadge = "_1f-j";
export var notificationDot = "_1f-r";
export var optionsContainer = "_1f-h";
export var primaryNav = "_1f-0";
export var primaryNavDivider = "_1f-v";
export var primaryNavResizeHandle = "_1f-2";
export var primaryNavResizing = "_1f-1";
export var primaryNavTabSection = "_1f-u";
export var primaryTab = "_1f-p";
export var primaryTabIconBox = "_1f-s";
export var secondaryNav = "_1f-3";
export var selected = "_1f-t";
export var settingsNav = "_1f-4";
export var settingsNavItems = "_1f-5";
export var show = "_1f-d";
export var sideNav = "_1f-l";
export var teamItem = "_1f-a";
export var userProfileItem = "_1f-b";